<template>
  <SearchBarColumn
    v-if="products && products.length"
    class="suggestions-right-column"
    :title="title"
    :isShowAllVisible="!!productsCount || productsCount > 3"
    :showAllRoute="{
      name: 'search',
      query: { q: query },
    }"
  >
    <div v-for="(suggestion, index) in products" :key="suggestion.id">
      <a tabindex="0" @keydown.esc="onBlur" :href="suggestion.url" class="suggestion-link" @click="clickProduct(suggestion, index)">
        <div class="suggestion-image">
          <suspense>
            <ResponsiveImage :lazy="false" :url="suggestion.imageUrl" :widths="[130]" :breakpoints="[130]" />
          </suspense>
        </div>
        <div>
          <div class="suggestion-title">{{ suggestion.title }}</div>
          <div v-if="suggestion.variation && suggestion.variation.length > 1">
            <span class="suggestion-variation" v-for="variation in suggestion.variation" :key="variation.id">
              <suspense>
                <ResponsiveImage :lazy="false" :url="variation.variationImageUrl" :widths="[12]" :breakpoints="[12]" />
              </suspense>
            </span>
          </div>
          <div class="suggestion-price bold accent">{{ suggestion.price }}</div>
        </div>
      </a>
    </div>
  </SearchBarColumn>
</template>

<script>
export default { name: 'SearchBarProducts' };
</script>

<script setup>
import { computed } from 'vue';
import SearchBarColumn from './SearchBarColumn.vue';
// should be loaded with SFC version of
// ResponsiveImage: defineAsyncComponent(() => import('@/components/commons/ResponsiveImage.vue')),
import ResponsiveImage from '@/components/commons/ResponsiveImage.vue';

const props = defineProps({
  query: {
    type: String,
    required: true,
  },
  products: {
    type: Object,
    required: true,
  },
  productsCount: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['clickProduct']);

function clickProduct(suggestion, index) {
  emit('clickProduct', suggestion, index);
}

const title = computed(() => {
  return `${props.productsCount} Product${!props.productsCount || props.productsCount > 1 ? 's' : ''}`;
});
</script>
